import {
	MimaButton,
	MimaDropdown,
	MimaText,
	Modal,
} from '../../components';
import styles from '../../assets/styles/Employees/Employees.module.scss';
import successImg from '../../assets/img/Successful.png';
import { employeeStore } from '../../stores';
import { Formik } from 'formik';

import React from 'react';

const AddSalesSheet = ({
	closeModal,
	uploaded,
	uploadClick,
	file,
	selectClick,
	loading,
}) => {
	return (
		<Modal closeModal={closeModal} goBack={closeModal}>
			<MimaText variant="subtitle" mb={3}>
				Upload Sales Sheet
			</MimaText>
			{!uploaded && (
				<>
					<MimaText
						variant="small"
						mb={2}
						width={38}
						align="center"
						color="var(--color-primary)">
						To add your Employees sales sheet in bulk kindly click the button below and
						download our excel template.
					</MimaText>

					<a
						href="https://res.cloudinary.com/mima-business/raw/upload/v1667988860/Employee-Bulk-Create-Template_k8didy_aqyhtp.xlsx"
						target="_blank" rel="noreferrer">
						<MimaButton
							title="Download Template"
							variant="colorable"
							buttonColor="var(--color-dark)"
							mb={5}
						/>
					</a>

					<MimaText
						variant="small"
						mb={2}
						width={38}
						align="center"
						color="var(--color-primary)">
						Fill the downloaded template with your employee sales information and then
						upload in the next button
					</MimaText>
					<Formik
						initialValues={{
						}}
						onSubmit={uploadClick}>
						{({
							handleChange,
							handleBlur,
							handleSubmit,
							setFieldValue,
							values,
							errors,
							touched,
						}) => (
							<>
								<MimaButton
									title="Select file"
									variant="outlined"
									width={38}
									onClick={selectClick}
								/>
								<MimaText
									variant="small"
									mt={2}
									width={38}
									align="center"
									color="var(--color-primary)">
									{file?.name || ''}{' '}
								</MimaText>

								<MimaButton
									disabled={loading}
									loading={loading}
									title="Upload Employees Sales Sheet"
									type="submit"
									onClick={handleSubmit}
								/>
							</>
						)}
					</Formik>
				</>
			)}
			{uploaded && (
				<>
					<img
						src={successImg}
						alt="Upload success"
						className={styles.success}
					/>
					<MimaText
						variant="h3"
						width={38}
						align="center"
						color="var(--color-success)"
						mb={2}>
						Upload <br />
						Successful
					</MimaText>
					{/* <MimaText width={38} align="center" color="var(--color-primary)">
						You successfully uploaded 35 employees
					</MimaText> */}
					<MimaButton title="Continue" onClick={closeModal} mt={3} />
				</>
			)}
		</Modal>
	);
};

export default AddSalesSheet;
